//@flow
import ko from 'rgs-knockout';
import type {PureComputed, Observable, ObservableArray} from 'rgs-knockout';

import {withProps} from "../helpers";

export type ListOptions = {
	items: ObservableArray<any> | Array<any>,
	minCount: Observable<number> | number;
	isExpand: ObservableArray<boolean> | Array<boolean>,
	isItemHovered: boolean,

	TEXT_ON_EXPAND: string;
	TEXT_ON_HIDE: string;
}

const TEXT_ON_EXPAND_BLOCK = 'Показать все';
const TEXT_ON_HIDE_BLOCK = 'Свернуть';

export default class List {
	_source: PureComputed<Observable<Array<any>> | Array<any>>;

	items: PureComputed<Observable<Array<any>> | Array<any>>;
	maxCount: PureComputed<Observable<number> | number>;
	minCount: PureComputed<Observable<number> | number>;
	isItemHovered: boolean;

	isExpand: Observable<boolean> ;
	text: PureComputed<Observable<string> | string>;

	constructor (options: ListOptions) {
		const {
			items = [],
			minCount = 5,
			isExpand = false,
			isItemHovered = true,
			TEXT_ON_EXPAND = TEXT_ON_HIDE_BLOCK,
			TEXT_ON_HIDE = TEXT_ON_EXPAND_BLOCK,
		} = withProps(options);

		this._source = ko.pureComputed(() => ko.unwrap(items));
		this.isExpand = ko.observable(isExpand);

		this.minCount = ko.pureComputed(() => ko.unwrap(minCount));
		this.maxCount = ko.pureComputed(() => this._source().length);

		this.text = ko.pureComputed(() => this.isExpand() ? TEXT_ON_EXPAND : TEXT_ON_HIDE);
		this.isTextVisible = ko.pureComputed(() => this.maxCount() > this.minCount());

		this.items = ko.pureComputed(this.adjustListItems, this);
		this.isItemHovered = isItemHovered;
	}

	adjustListItems () {
		let count = this.minCount();
		const items = this._source();

		count = this.isExpand() ? items.length : count;

		return items.slice(0, count);
	}

	handleClickOnExpander = (): void => {
		const old = this.isExpand.peek();

		this.isExpand(!old);
	}
}
